module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch5"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch5.jpg",
      "width": "5%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The red liquid gleams. A vampire places a plastic straw in one of the goblets and holds it toward you. “Sip?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("You lick your dry lips.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("You’d die for a gulp.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But you swallow hard and shake your head.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("You can’t let yourself drink it. If you do, and it’s blood — and you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("know")]), _vm._v(" it’s blood — you’re pretty sure you’ll be a vampire forever. And forever is a long time.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No,” you repeat. “I’ll pass on the blood!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sorry you feel that way,” Countess Yvonne says.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She gives one short nod to the others. They glide toward you. Closing in on you.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In desperation, you search for a weapon. But the only thing you see are the goblets of blood.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Frantically, you dart to the table and lift a goblet. You toss the whole glassful of liquid into the countess’s face!")]), _vm._v(" "), _c('p', {
    staticClass: "extractLetterText",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Turn to "), _c('span', {
    attrs: {
      "href": "#/e9780545820660_ch016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PAGE 16")]), _vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-491311f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545820660_ch005.vue
// module id = 78
// module chunks = 0